export enum ProductNames {
  CHATKEEPERBOT,
  PRESSCODEBOT,
  TGSCOUTBOT,
  TGPULSE,
  ADSTORYBOT,
  Modero
}

export type CompanyProduct = {
  product:ProductNames
  title:string
  description:string
  logo:string
  link:string
}
